export default __webpack_public_path__ + "static/media/fino_logo.83c69f25.png";